import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Foorter";
import MainLayout from "./layouts/MainLayout";
import Home from "./pages/Home";
import News from "./pages/News";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ReadMore from "./pages/ReadMore";
import NewsDetails from "./pages/NewsDetails";
import BlogsOverview from "./pages/BlogsOverview";

function App() {
  // PUBLIC_URL is "" at the site root and "/react-app" when the build is served
  // from a subfolder (PUBLIC_URL=/react-app npm run build) - so the same source
  // works on the test server and in production without editing this file.
  return (
    <Router basename={process.env.PUBLIC_URL || "/"}>
      <Header />

      <MainLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/read/:date" element={<ReadMore />} />
          <Route path="/news" element={<News />} />
          <Route path="/blogs" element={<BlogsOverview type="blog" />} />
          <Route path="/blogs/:slug" element={<NewsDetails type="blog" />} />
          <Route path="/news/:slug" element={<NewsDetails type="news" />}/>
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </MainLayout>

      <Footer />
    </Router>
  );
}

export default App;